import { Nav } from "../../layouts/Nav/Nav";
import { Footer } from "../../layouts/Footer/Footer";
import "../../styles/TermsAndCondition.scss";

export function TermsAndCondition() {
  return (
    <>
      <div className="container">
        <div className="nav-container">
          <Nav />
        </div>
        <div className="terms-content">
          <h1>TERMS & CONDITION</h1>
          <div>
            <h2>APPLICATION Storiya.app GENERAL TERMS OF USE</h2>
            <p>
              With these General Terms of Use (hereinafter: the General Terms),
              a company Cypher d.o.o. with the seat in Osijek, Medulinska 2,
              Croatia, registered with the Commercial Court Osijek, MBS:
              030249088, PIN: 14765764374 (hereinafter: Cypher) determines the
              obligations, rights and terms of use for the mobile application
              Storiya.app for creation and editing of the images based on the
              use of artificial intelligence, and on the basis of data in the
              form of text or images provided by the Users (hereinafter:
              Application).
            </p>
            <p>
              These General Terms apply to any upgrade and/or new versions
              and/or any other change or update to the Application.
            </p>
          </div>

          <div>
            <h2>Downloading the Application</h2>
            <p>
              Application Users (hereinafter: Users) are adult natural persons
              (persons above 18 years of age).
            </p>
            <p>
              The functionalities of Application may be reviewed via web browser
              on the website https://Storiya.app/. The user may download the
              Application, depending on the existing type of smartphone /
              tablet, and availability through online or mobile app stores,
              always in the manner and under the conditions specified by the
              mobile store.
            </p>
            <p>
              Registration for the user is free of charge, but each action
              undertaken in Application for the purpose of editing or creating
              images is charged with tokens (“in-app currency”) that are
              available for purchase within the Application by one-time purchase
              or through a monthly subscription.
            </p>
            <p>
              For all transactions in the Application, the services of the
              Google Play platform are applied in accordance with the terms and
              conditions available at:
              https://play.google.com/intl/en_us/about/play-terms/index.html.
            </p>
            <p>
              The registration is required for the use of the Application
              functionalities.
            </p>
            <p>In order use the Application the User must be registered via</p>
            <ul className="terms_condition">
              <li>Email,</li>
              <li>Google or Facebook user account.</li>
            </ul>
            <p>Data collected during registration processa are:</p>
            <ul className="terms_condition">
              <li>email address</li>
              <li>
                device information - operating system version and name, device
                model
              </li>
            </ul>
            <p>
              By sharing the above mentioned data the users confirm that they
              have carefully read the applicable General Terms, agree with them
              and accept these in full, they confirm that they are above 18
              years of age and fulfill the other conditions for the use of
              Application.{" "}
            </p>
            <p>
              Processing and protection of User's personal data carried out by
              Cypher are regulated in the Privacy Policy available at
              https://Storiya.app/privacy-policy .
            </p>
            <p>
              The user may delete his account at any time by using the
              Application. Deleting an account from the system deletes all data
              related to the user.
            </p>
          </div>

          <div>
            <h2>Limitation of liability</h2>
            <p>
              Cypher assumes no liability and gives no guarantees to the User
              for possible inactivity or inability to use the Application but
              shall only endeavour to ensure smooth operation of the
              Application. The liability for damages of Cypher for any damage
              caused to the User or a third party in connection with the use of
              the Application shall be excluded, except for damages caused by
              Cypher by willful misconduct or by gross negligence. The damage
              may result in loss of production, work, the usability of data,
              profits, or revenues. Contractual parties also exclude mutual
              liability for any other specific, indirect, accidental, or
              consequential damages, regardless of the possibility to foresee
              their occurrence.
            </p>
            <p>
              The liability for damages of Cypher arising from/or in connection
              with a contractual or non-contractual relationship mutually
              negotiated between the Users or third parties shall be excluded,
              in particular for damages arising from ignorance or lack of
              knowledge, omissions or imprecisions in performing actions in
              Application, which may result in business arrangements entered
              between the users while using the Application.
            </p>
            <p>
              The functionality of the Application and the use of its features
              are conditioned by the one-time purchase or subscription payment,
              though their cannclation may lead to the inaccessibility of the
              Application, partially or in full.
            </p>
            <p>
              The Application uses independent external services and
              applications to display certain functionalities, included, but not
              limited to the services of the company Google LLC. The use of
              these services is subject to the terms of use of the external
              service specified by the owner of the service, and Cypher assumes
              no liability in this regard and makes no warranties.
            </p>
            <p>
              - Cypher is not responsible for occasional inactivity of the
              Application, possible inaccuracy of information and any damage
              and/or loss of income.
              <br />
              - Cypher is not liable for any damage, e.g. arising from access to
              information, use of or inability to use information or any errors
              or deficiencies in their content.
              <br />
              - Cypher is not liable for any loss or damage that may occur due
              to unauthorised use of the Application.
              <br />- Cypher is not responsible for any errors or damage
              resulting from the transmission of incorrect information and/or
              other activity of the User, and in particular is not responsible
              to the fullest extent permitted by law for harmful, immoral,
              offensive, defamatory or any other illicit or illegal content that
              the Application User would make available or visible in any way
              whatsoever, or thereby cause damage to third parties.
            </p>
            <p>
              - Cypher also reserves the right to change, add or remove content
              posted in the Application at any time, without prior notice. All
              Users make use of all published content at their own risk.
            </p>
          </div>
          <div>
            <h2>User’s obligations</h2>
            <p>
              The user shall be responsible for all activities carried out using
              the Application. In case of unauthorised use of the data or
              reasonable suspicion of unauthorised access to data, the user
              shall be obliged to notify Cypher thereof without delay.
              <br />
              Cypher shall not be liable for any damage suffered by the user due
              to the misuse or unauthorised use by the third party of the user
              account or password with which the third party is registered, i.e.
              logged in to Application.
              <br />
              The User agrees not to use the Application for unlawful purposes
              or purposes contrary to these General Terms.
            </p>
          </div>

          <div>
            <h2>Exception from the right of withdrawal</h2>
            <p>
              The subject matter of the contract is the supply of digital
              content not supplied on a tangible medium, and the contract places
              the Application User under the obligation to pay the agreed
              considaration. The Application User acknowledges that the
              execution of the contract – provision of digital content -
              commences with prior consent of the Application User, and in this
              regard the Application User acknowledges to lose the right of
              withdrawal from the contract. Furthermore, is shall be considered
              that the service is fully executed by the Cypher in the moment the
              Application User pays the agreed consideration. The Application
              User has the right to terminate the contract only in case Cypher
              has not enabled the delivery of the digital content after the
              payment.{" "}
            </p>
          </div>

          <div>
            <h2>Intellectual property rights</h2>
            <p>
              Cypher does not transfer to the User any copyrights or industrial
              property rights, nor does it grant them the right to use any
              trademarks, logos or corporate identity owned or held by Cypher.
              The User, for example, may not make copies of the the Application
              or modify or otherwise interfere with the operation of the
              Application.
            </p>
          </div>
          <div>
            <h2>Complaint Handling and Dispute Resolution</h2>
            <p>
              The user may file a complaint concerning the operation of the
              Application or undaertaken purchases by contacting Cypher on the
              web site https://Storiya.app .{" "}
            </p>
            <p>
              Cypher and the User shall settle any possible disputes amicably.
              If that is not possible, the disputes will be resolved before a
              competent court in Osijek, the Republic of Croatia.
            </p>
          </div>
          <div>
            <h2>Amendments to the General Terms </h2>
            <p>
              The current General Terms and Conditions are published on the
              page: https://Storiya.app.
              <br />
              The same applies to all changes and additions to the General Terms
              and Conditions resulting from the amended business policy of the
              Cypher company, and they enter into force on the date of
              publication on the specified page.
              <br />
              It is considered that the user has been notified of the amendment
              on the date of receiving the notification on publication of the
              new or amended General Terms and Conditions.
              <br />
              If the user does not agree with the amended or supplemented
              General Terms and Conditions, he must stop using the Application.
            </p>
          </div>
          <div>
            <h2>Force majeure</h2>
            <p>
              The Cypher shall not be liable for non-performance of any
              obligation in event where the non-performance of the obligation
              results from the force majeure – an event beyond its control, does
              not result in negligence which could not be avoided, foreseen or
              eliminated, and directly affects the performance of the
              obligations. Force Majeure includes, but is not limited to:
              natural disasters, state of war, strike, embargo, earthquake etc.{" "}
            </p>
          </div>
          <div>
            <p>
              These General Terms and Conditions shall enter into force on 16th
              of January 2024.
            </p>
          </div>
        </div>
        <div className="footer">
          <Footer />
        </div>
      </div>
    </>
  );
}
